module.exports = __webpack_public_path__ + "img/bmsOPENCARD.6aed9809.jpg";